import { useState } from 'react';
import { api, ApiError } from '../api';

export function Login({ onSignedIn, namedUsers }: { onSignedIn: () => void; namedUsers: boolean }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password, email.trim());
      onSignedIn();
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : String(cause));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="centered">
      <form className="panel" onSubmit={submit}>
        <div className="card stack">
          <h1>Reporting Dashboard</h1>
          <p className="muted small">
            {namedUsers
              ? 'Sign in with your email and password.'
              : 'Enter the setup password, then add your own login under Settings → Users.'}
          </p>
          {namedUsers ? (
            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="text"
                inputMode="email"
                autoComplete="username"
                autoFocus
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
          ) : null}
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              autoFocus={!namedUsers}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          {error ? <div className="banner error">{error}</div> : null}
          <button type="submit" className="btn btn-primary" disabled={busy || !password || (namedUsers && !email.trim())}>
            {busy ? 'Checking…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
}
